export var PaymentTypes;
(function (PaymentTypes) {
    let PaymentSteps;
    (function (PaymentSteps) {
        PaymentSteps["PAYMENT_1"] = "WalletAddress";
        PaymentSteps["PAYMENT_2"] = "BankDetails";
        PaymentSteps["PAYMENT_3"] = "MobileMoneyDetails";
        PaymentSteps["PAYMENT_4"] = "OrderSent";
    })(PaymentSteps = PaymentTypes.PaymentSteps || (PaymentTypes.PaymentSteps = {}));
    let SellPaymentSteps;
    (function (SellPaymentSteps) {
        SellPaymentSteps["PAYMENT_2"] = "GenerateWalletDetails";
        SellPaymentSteps["PAYMENT_3"] = "SellWalletDetails";
        SellPaymentSteps["PAYMENT_4"] = "SellOrderSent";
        SellPaymentSteps["PAYMENT_5"] = "AuthoriseMinipay";
        SellPaymentSteps["PAYMENT_6"] = "MinipayViewAddress";
        SellPaymentSteps["PAYMENT_7"] = "MinipayAuthorizationFailed";
        SellPaymentSteps["PAYMENT_8"] = "PartnerSellRedirect";
        SellPaymentSteps["PAYMENT_9"] = "MinipayTransactionError";
        SellPaymentSteps["SAVE_PAYOUT_ACCOUNT"] = "SavePayoutAccount";
    })(SellPaymentSteps = PaymentTypes.SellPaymentSteps || (PaymentTypes.SellPaymentSteps = {}));
})(PaymentTypes || (PaymentTypes = {}));
